import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import { Tabs, Tag, Modal, Progress } from "antd";

const ArbitrationCaseDetails = () => {
  const { caseId } = useParams();

  const [data, setData] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [loading, setLoading] = useState(true);

  const cookies = new Cookies();
  const token = cookies.get("authToken");

  useEffect(() => {
    fetchCaseDetails();
  }, []);

 const fetchCaseDetails = async () => {
  try {
    setLoading(true);

    const res = await axios.get(
      "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/cms-case-inspection",
      {
        params: {
          cd_Case_ID: caseId,
          "module-id": "commence",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setData(res.data.response);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false); // ✅ IMPORTANT FIX
  }
};

  const safe = (val) => val || "N/A";

//   if (!data) return <div className="p-6">Loading...</div>;
if (loading) {
  return (
    <div className="lg:ml-64 mt-28 p-6 animate-pulse space-y-6">

      {/* Header Skeleton */}
      <div className="bg-white p-6 rounded-xl shadow space-y-3">
        <div className="h-6 bg-gray-300 rounded w-1/3"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
      </div>

      {/* Cards Skeleton */}
      <div className="grid grid-cols-3 gap-4">
        <div className="h-20 bg-gray-200 rounded"></div>
        <div className="h-20 bg-gray-200 rounded"></div>
        <div className="h-20 bg-gray-200 rounded"></div>
      </div>

      {/* Content Skeleton */}
      <div className="h-40 bg-gray-200 rounded"></div>
    </div>
  );
}

  const commence = data?.data?.commence?.[0];
  const efiling = data?.data?.efiling || [];
  const schedule = data?.data?.scheduleArbitation || [];
  const recordings = data?.data?.recording || [];

  // 🔥 Progress
  let progress = 25;
  if (efiling.length) progress = 50;
  if (schedule.length) progress = 75;
  if (recordings.some((r) => r.status === "stopped")) progress = 100;

  const FileCard = ({ url, title, onView }) => {
  const isPdf = url?.includes(".pdf");

  return (
    <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg border hover:shadow">
      <div>
        <p className="font-medium">{title}</p>
        <p className="text-xs text-gray-500 truncate w-48">{url}</p>
      </div>

      <div className="flex gap-2">
        {isPdf && (
          <button
            onClick={() => onView(url)}
            className="text-blue-600 text-sm"
          >
            👁 View
          </button>
        )}

        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="text-green-600 text-sm"
        >
          ⬇ Download
        </a>
      </div>
    </div>
  );
};

  return (
    <div className="lg:ml-64 mt-28 md:mt-24 p-4 md:p-6 lg:p-8 bg-gray-100 min-h-screen">

      {/* 🔥 HEADER */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <h2 className="text-2xl font-bold">
          Case ID: {commence?.cd_Case_ID || caseId}
        </h2>

        <p className="text-gray-600">
          {safe(commence?.claimant_Details?.[0]?.claimant_name)} vs{" "}
          {safe(commence?.respondent_Details?.[0]?.respondent_name)}
        </p>

        <p><b>Dispute:</b> {safe(commence?.nature_of_Despute)}</p>
        <p><b>Claim Value:</b> ₹{safe(commence?.value_of_Claim)}</p>

        <div className="mt-3 flex gap-3 flex-wrap">
          <Tag color="blue">In Progress</Tag>
          {recordings.some((r) => r.status === "active") && (
            <Tag color="green">Live Recording</Tag>
          )}
        </div>

        <div className="mt-4">
          <Progress percent={progress} />
        </div>
      </div>

      {/* 🔥 STATS */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
        {Object.entries(data.typeTotals).map(([key, value]) => (
          <div key={key} className="bg-white p-4 rounded-xl shadow text-center">
            <p className="text-lg font-bold">{value}</p>
            <p className="text-sm text-gray-500 capitalize">{key}</p>
          </div>
        ))}
      </div>

      {/* 🔥 CLICKABLE PERSON CARDS */}
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        {["claimant", "respondent", "arbitrator"].map((type) => {
          const map = {
            claimant: commence?.claimant_Details,
            respondent: commence?.respondent_Details,
            arbitrator: commence?.arbitrator_Details,
          };

          const first = map[type]?.[0];

          return (
            <div
              key={type}
              onClick={() =>
                setSelectedPerson({ type, data: map[type] })
              }
              className="bg-white p-4 rounded-xl shadow cursor-pointer hover:shadow-lg"
            >
              <h3 className="font-semibold capitalize text-blue-600">
                {type}
              </h3>
              <p>
                {first?.claimant_name ||
                  first?.respondent_name ||
                  first?.arbitrator_name}
              </p>
            </div>
          );
        })}
      </div>

{/* 📄 Arbitration Petition */}
<div className="bg-white p-4 rounded-xl shadow mb-6">
  <h3 className="font-semibold mb-3 text-purple-600">📄 Case Petition</h3>

  {commence?.arbitration_petition?.length ? (
    <div className="space-y-2">
      {commence.arbitration_petition.map((doc, i) => (
        <FileCard
          key={i}
          url={doc}
          title={`Petition ${i + 1}`}
          onView={setPdfUrl}
        />
      ))}
    </div>
  ) : (
    <p className="text-gray-500">No Petition Available</p>
  )}
</div>


      {/* 🔥 TABS */}
      <Tabs
        items={[
          {
            key: "1",
            label: "E-Filing",
            children: efiling.length ? (
              efiling.map((item) => (
                <div key={item._id} className="bg-white p-4 rounded-xl shadow mb-4">
                  <h3 className="font-semibold">{item.document_type}</h3>
                  <p>{item.subject}</p>

                  <p className="text-sm text-gray-500 mt-2">
                    Created: {new Date(item.created_at).toLocaleString()}
                  </p>

                  <div className="mt-2">
                    <b>Sent To:</b>
                    {[...item.sendTo.claimant_names,
                      ...item.sendTo.respondent_names,
                      ...item.sendTo.arbitrator_names].map((p, i) => (
                      <p key={i}>👤 {p.name}</p>
                    ))}
                  </div>

                  {item.serve_Document?.map((doc, i) => (
                    <button
                      key={i}
                      onClick={() => setPdfUrl(doc)}
                      className="text-blue-600 mt-2"
                    >
                      📄 View Document
                    </button>
                  ))}
                </div>
              ))
            ) : <p>No Data</p>,
          },

          {
            key: "2",
            label: "Schedule",
            children: schedule.map((item) => (
              <div key={item._id} className="bg-white p-4 rounded-xl shadow mb-4">
                <p><b>Date:</b> {new Date(item.date).toLocaleDateString()}</p>
                <p><b>Time:</b> {item.time} - {item.end_time}</p>
                <p><b>Room:</b> {item.vc_room_number}</p>

                {/* <a href={item.vc_url} target="_blank" className="text-blue-600">
                  🎥 Join Meeting
                </a> */}
              </div>
            )),
          },

          {
            key: "3",
            label: "Recording",
            children: recordings.map((rec) => (
              <div key={rec._id} className="bg-white p-4 rounded-xl shadow mb-4">
                <p>
                  <b>Status:</b>{" "}
                  <Tag color={rec.status === "active" ? "green" : "red"}>
                    {rec.status}
                  </Tag>
                </p>

                <p><b>Room:</b> {rec.roomNumber}</p>
                <p><b>Started:</b> {new Date(rec.startedAt).toLocaleString()}</p>

                {rec.stoppedAt && (
                  <p><b>Stopped:</b> {new Date(rec.stoppedAt).toLocaleString()}</p>
                )}

                {rec.mp4Url && (
                  <button
                    onClick={() => setVideoUrl(rec.mp4Url)}
                    className="text-blue-600 mt-2"
                  >
                    ▶️ Play Recording
                  </button>
                )}
              </div>
            )),
          },
        ]}
      />

      {/* 🔥 PERSON MODAL */}
      <Modal
        open={!!selectedPerson}
        onCancel={() => setSelectedPerson(null)}
        footer={null}
      >
        <h2 className="text-xl font-bold mb-4 capitalize">
          {selectedPerson?.type} Details
        </h2>

        {selectedPerson?.data?.map((p, i) => (
          <div key={i} className="mb-3 border-b pb-2">
            <p><b>Name:</b> {p.claimant_name || p.respondent_name || p.arbitrator_name}</p>
            <p><b>Email:</b> {p.claimant_email || p.respondent_email || p.arbitrator_email}</p>
            <p><b>Mobile:</b> {p.claimant_mobile_number || p.respondent_mobile_number || p.arbitrator_mobile_number}</p>
            <p><b>Address:</b> {p.claimant_address || p.respondent_address || p.arbitrator_address}</p>
          </div>
        ))}
      </Modal>

      {/* 🎥 VIDEO MODAL */}
      <Modal open={!!videoUrl} onCancel={() => setVideoUrl(null)} footer={null} width={800}>
        <video src={videoUrl} controls className="w-full" />
      </Modal>

      {/* 📄 PDF MODAL */}
     <Modal
  open={!!pdfUrl}
  onCancel={() => setPdfUrl(null)}
  footer={null}
  width="90%"
  centered
  closable={false}
  bodyStyle={{ padding: 0 }}
>
  <div className="flex flex-col h-[85vh] bg-black rounded-lg overflow-hidden">

    {/* 🔥 HEADER (CUSTOM CLOSE + ACTIONS) */}
    <div className="flex justify-between items-center px-4 py-2 bg-gray-900 text-white">

      <p className="text-sm truncate">
        📄 Document Preview
      </p>

      <div className="flex gap-4 items-center">

        {/* Open in new tab */}
        <a
          href={pdfUrl}
          target="_blank"
          rel="noreferrer"
          className="text-sm hover:underline"
        >
          Open ↗
        </a>

        {/* Close Button */}
        <button
          onClick={() => setPdfUrl(null)}
          className="bg-red-500 hover:bg-red-600 px-3 py-1 rounded text-sm"
        >
          ✕ Close
        </button>
      </div>
    </div>

    {/* 🔥 PDF VIEW */}
    <div className="flex-1 bg-gray-800">
      <iframe
        src={pdfUrl}
        className="w-full h-full"
        title="PDF Viewer"
      />
    </div>

  </div>
</Modal>
    </div>
  );
};

export default ArbitrationCaseDetails;